var defaultFilterItemsMultiselect = function defaultFilterItemsMultiselect(items, filter) {
  return items.filter(function (item) {
    return filter && item.name.toLowerCase().startsWith(filter.toLowerCase());
  });
};
var filterItemsMultiselect = function filterItemsMultiselect(items, filter, customFilterItems, maxItems) {
  if (!items) return [];
  var filtered = customFilterItems ? customFilterItems(items, filter) : defaultFilterItemsMultiselect(items, filter);
  return filtered.slice(0, maxItems || filtered.length);
};

export { filterItemsMultiselect };
